import { writable } from 'svelte/store';
import { loadServices } from '../api/service.api';
export default class ServiceService {
    constructor(dataProvider) {
        this._processingServices = writable(false);
        this._errorServices = writable(false);
        this._services = writable([]);
        this._processingMainServices = writable(false);
        this._errorMainServices = writable(false);
        this._mainServices = writable([]);
        this._dataProvider = dataProvider;
    }
    loadServices(categoryId = null) {
        this._processingServices.set(true);
        loadServices(categoryId, this._dataProvider.showSiteUrl, this._dataProvider.servicesGroupId, this._dataProvider.structureGroupId, this._dataProvider.vocabularyGroupId)
            .then((response) => {
            this._services.set(response);
            this._errorServices.set(false);
        })
            .catch(() => this._errorServices.set(true))
            .finally(() => this._processingServices.set(false));
    }
    loadMainServices(categoryId = null) {
        this._processingMainServices.set(true);
        loadServices(categoryId, this._dataProvider.showSiteUrl, this._dataProvider.servicesGroupId, this._dataProvider.structureGroupId, this._dataProvider.vocabularyGroupId)
            .then((response) => {
            this._mainServices.set(response);
            this._errorMainServices.set(false);
        })
            .catch(() => this._errorMainServices.set(true))
            .finally(() => this._processingMainServices.set(false));
    }
    resetMainServices() {
        this._mainServices.set([]);
    }
    get processingServicesSubs() {
        return this._processingServices;
    }
    get errorServicesSubs() {
        return this._errorServices;
    }
    get servicesSubs() {
        return this._services;
    }
    get processingMainServicesSubs() {
        return this._processingMainServices;
    }
    get errorMainServicesSubs() {
        return this._errorMainServices;
    }
    get mainServicesSubs() {
        return this._mainServices;
    }
}
